import React from 'react';
import WorkList from "../components/editor/WorkList";
import Editor from "../components/editor/Editor";
import CreateButton from '../components/editor/CreateButton'
import rtd from "../../consumers/rtd";

function WorkArea({rtd, list, single, url}) {

    const listRef = rtd.ref(list);

    return (
        <div className="container-fluid py-8">
            <div className="row px-6">
                <div className="col-md-3">

                    <ul className="list-group">
                        <CreateButton
                            reference={listRef}
                            url={url}
                        />
                        <WorkList
                            reference={listRef}
                            url={url}
                        />
                    </ul>
                </div>
                <div className="col-md-9">
                    <Editor reference={rtd.ref(single)}/>
                </div>
            </div>
        </div>
    );
}

export default rtd(WorkArea);


// WEBPACK FOOTER //
// ./src/admin/subscribers/WorkArea.js